/*
 * File: login.vue.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:54:06
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { IQuery, IQueryDefault } from "@root/core";
import { BaseComponent } from "@root/components";

import data from "@/package.json";
const kUsername = `${data.name}:username`;
const kPassword = `${data.name}:password`;
const kRememberMe = `${data.name}:rememberMe`;

/// refined at 2023/12/13
@Component
export default class Login extends BaseComponent {
    username: string | null = "";
    password: string | null = "";
    rememberMe: boolean = false;

    query: IQuery = IQueryDefault();

    private mounted() {
        const rememberMe: boolean =
            localStorage.getItem(kRememberMe) === "true" ? true : false;
        const username: string | null = localStorage.getItem(kUsername);
        const password: string | null = localStorage.getItem(kPassword);
        this.rememberMe = rememberMe;
        if (this.rememberMe) {
            this.username = username;
            this.password = password;
        }
    }

    async login() {
        try {
            await this.$login(
                {
                    username: this.username as any,
                    password: this.password as any,
                },
                this.query,
            );
            /// save local storage
            localStorage.setItem(kRememberMe, this.rememberMe ? "true" : "false");
            localStorage.setItem(
                kUsername,
                this.rememberMe ? (this.username as any) : "",
            );
            localStorage.setItem(
                kPassword,
                this.rememberMe ? (this.password as any) : "",
            );

            /// redirect
            this.$home();
        } catch (e) {
            /// take the error of login failed
        }
    }
}
